/* v4.8 bento homepage: carousel arrows. Everything else is CSS. */
window.lcSlide = function (btn, dir) {
  var caro = btn.closest('.sec').querySelector('.caro');
  if (!caro) return;
  var card = caro.querySelector('.pcard');
  if (!card) return;
  caro.scrollBy({ left: dir * (card.offsetWidth + 10) * 2, behavior: 'smooth' });
};
